// extracted by mini-css-extract-plugin
module.exports = {"heading":"heading_heading__cy6ep","h0":"heading_h0____LwV","h1":"heading_h1__NeBnZ","h2":"heading_h2__ZcWJw","h3":"heading_h3__cuaor"};